import * as types from "../../actions/ActionTypes";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const checkPaymentStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CHECK_PAYMENT_STATUS_START:
      return { ...state, loading: true, error: null };
    case types.CHECK_PAYMENT_STATUS_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case types.CHECK_PAYMENT_STATUS_ERROR:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default checkPaymentStatusReducer;
